import * as React from 'react';

var _path, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgWeb = function SvgWeb(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#linearGradientWebIcon)",
        d: "M60 0C26.916 0 0 26.916 0 60s26.916 60 60 60 60-26.916 60-60S93.084 0 60 0M45.532 8.07c-2.55 2.564-4.879 5.936-6.891 10.3-1.537 3.331-2.866 7.168-3.976 10.86H15.752a54.05 54.05 0 0 1 29.78-21.16M12.054 35.385H33.14c-1.432 6.769-2.266 14.153-2.44 21.538H6.236c.42-7.692 2.471-14.77 5.818-21.538M6.25 63.077H30.71c.187 7.692 1.035 15.077 2.484 21.538h-21.01C8.797 78.154 6.706 71.077 6.25 63.077m9.67 27.692h18.813c1.096 4 2.401 7.447 3.906 10.71 1.972 4.274 4.267 7.651 6.782 10.269-12.082-3.402-22.454-10.825-29.5-20.979m41.002 22.575c-5.846-2.021-11.955-9.959-15.812-22.575h15.812zm0-28.728H39.455c-1.462-6.154-2.394-13.539-2.593-21.539h20.06zm0-27.693H36.858c.181-7.385 1.064-14.769 2.578-21.538h17.487zm0-27.692H41.077c.913-2.77 1.915-5.684 3.1-8.254 3.6-7.802 8.13-12.795 12.746-14.327zm56.841 27.692H89.299c-.174-7.385-1.007-14.769-2.44-21.538h21.087c3.347 6.769 5.398 13.846 5.818 21.538m-9.516-27.692H85.335c-1.11-3.693-2.438-7.5-3.975-10.831-1.998-4.332-4.24-7.746-6.683-10.304 12.138 3.443 22.542 11.289 29.571 21.135M63.077 6.715c4.615 1.612 9.097 6.574 12.644 14.262 1.185 2.57 2.289 5.484 3.202 8.253H63.077zm0 28.67h17.487c1.514 6.769 2.397 14.153 2.578 21.538H63.077zm0 27.692h20.06c-.198 8-1.13 15.385-2.592 21.538H63.077zm0 50.2V90.769h15.812c-3.814 12.308-9.658 20.377-15.812 22.508m11.826-1.591c2.347-2.606 4.508-6.014 6.456-10.238a67.6 67.6 0 0 0 3.907-10.679h18.812c-6.982 10.154-17.231 17.472-29.175 20.917m32.914-27.07h-21.01c1.449-6.462 2.297-13.847 2.485-21.539h24.457c-.455 8-2.546 15.077-5.932 21.539"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "linearGradientWebIcon",
        x1: 0,
        x2: 144.84,
        y1: 120,
        y2: 61.478,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#5FBFFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B090F5"
    })))));
};

export { SvgWeb as ReactComponent };
//# sourceMappingURL=Web.svg.es.js.map
